import './ProfileSummary.scss'

import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from '../../common/router'
import { checkPermission } from '../../common/utils/helpers'
import {
  fetchProfile,
} from '@store/reducers/contactProfile/contactProfileSlice'
import {
  selectUserProfile,
  selectIsUserProfileLoading,
} from '@store/reducers/contactProfile/contactProfileSelectors'


const ProfileSummary = ({ userId }) => {
  const dispatch = useDispatch()
  const canEdit = checkPermission('user_edit')
  const userProfile = useSelector(state => selectUserProfile(userId)(state))
  const isLoading = useSelector(state => selectIsUserProfileLoading(userId)(state))

  useEffect(() => {
    const fetchProfileData = () => {
      dispatch(fetchProfile(userId))
    }

    if (userId) {
      fetchProfileData()
    }
  }, [userId, dispatch])

  if (isLoading) {
    return (
      <div className="profile-summary">
        <div className="profile-summary__loading">Loading profile information...</div>
      </div>
    )
  }

  if (!userProfile) {
    return (
      <div className="profile-summary">
        <div className="profile-summary__error">Profile information not available</div>
      </div>
    )
  }

  return (
    <div className="profile-summary">

      <div className="profile-summary__header">
        <div className="profile-summary__header-content">
          <h1 className="profile-summary__name">
            {userProfile.firstname} {userProfile.lastname}
          </h1>
          <div className="profile-summary__role">{userProfile.role || 'No role assigned'}</div>
        </div>

        {canEdit && (
          <Link
            to="singleUser"
            id={userId}
            className="profile-summary__edit-button"
            title="Edit User Profile"
          >
            <span className="profile-summary__edit-text">Edit</span>
          </Link>
        )}
      </div>

      <div className="profile-summary__content">
        <div className="profile-summary__section">
          <div className="profile-summary__section-title">Contact Information</div>
          <div className="profile-summary__field">
            <span className="profile-summary__label">Email</span>
            <span className="profile-summary__value">{userProfile.email || 'Not provided'}</span>
          </div>

          <div className="profile-summary__field">
            <span className="profile-summary__label">Phone</span>
            <span className="profile-summary__value">{userProfile.phone_number ? `+1 ${userProfile.phone_number}` : 'Not provided'}</span>
          </div>

          <div className="profile-summary__field">
            <span className="profile-summary__label">Cell Phone</span>
            <span className="profile-summary__value">{userProfile.cell_number ? `+1 ${userProfile.cell_number}` : 'Not provided'}</span>
          </div>
        </div>

        <div className="profile-summary__section">
          <div className="profile-summary__section-title">Professional Information</div>
          <div className="profile-summary__field">
            <span className="profile-summary__label">LOS User ID</span>
            <span className="profile-summary__value">{userProfile.los_id || 'Not provided'}</span>
          </div>

          {userProfile.nmls_id && (
            <div className="profile-summary__field">
              <span className="profile-summary__label">NMLS ID</span>
              <span className="profile-summary__value">{userProfile.nmls_id}</span>
            </div>
          )}

          {userProfile.branch && (
            <div className="profile-summary__field">
              <span className="profile-summary__label">Branch</span>
              <span className="profile-summary__value">{userProfile.branch}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

ProfileSummary.propTypes = {
  userId: PropTypes.any.isRequired,
}

export default ProfileSummary
